const STORAGE_KEYS = {
  ID_TOKEN: 'idToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
  USER_ID: 'userId',
};

/** One-time: move idToken from sessionStorage back to localStorage. */
const migrateSessionTokenToLocal = () => {
  if (typeof window === 'undefined') return;
  const inLocal = localStorage.getItem(STORAGE_KEYS.ID_TOKEN);
  if (inLocal) return;
  const inSession = sessionStorage.getItem(STORAGE_KEYS.ID_TOKEN);
  if (inSession) {
    localStorage.setItem(STORAGE_KEYS.ID_TOKEN, inSession);
    sessionStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
  }
};

export const getAuthToken = () => {
  migrateSessionTokenToLocal();
  return localStorage.getItem(STORAGE_KEYS.ID_TOKEN);
};

export const getAuthHeader = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.USER);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const getStoredUserId = () => {
  const userId = localStorage.getItem(STORAGE_KEYS.USER_ID);
  if (userId) return userId;

  const user = getStoredUser();
  return user?.uid || null;
};

/** Firebase id token from Auth API login/signup payload (camelCase or snake_case). */
export const extractIdTokenFromAuthPayload = (data) => {
  if (!data || typeof data !== 'object') return null;
  const auth = data.auth || data;
  return (
    auth.idToken ||
    auth.id_token ||
    data.idToken ||
    data.id_token ||
    data.token ||
    null
  );
};

export const extractRefreshTokenFromAuthPayload = (data) => {
  if (!data || typeof data !== 'object') return null;
  const auth = data.auth || data;
  return (
    auth.refreshToken ||
    auth.refresh_token ||
    data.refreshToken ||
    data.refresh_token ||
    null
  );
};

export const saveAuthSession = ({ idToken, refreshToken, user }) => {
  if (idToken) localStorage.setItem(STORAGE_KEYS.ID_TOKEN, idToken);
  if (refreshToken) localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  if (user) {
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    if (user.uid) localStorage.setItem(STORAGE_KEYS.USER_ID, user.uid);
  }
  sessionStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
};

export const clearAuthSession = () => {
  localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER);
  localStorage.removeItem(STORAGE_KEYS.USER_ID);
  sessionStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
};
